export const events = {
  SOCKET_TEST: '.socket-test',
  ACTION_MARKED_INCOMPLETE: '.actions.marked-incomplete',
  ACTION_CREATED: '.actions.created',
  ACTION_COMPLETED: '.actions.completed',
};
export const subscribeToPrivateUserChannel = (userId) => {
  return window.Echo.private(`App.User.${userId}`);
};

export const subscribeToWebsiteChannel = (websiteId) => {
  return window.Echo.private(`App.Models.Website.${websiteId}`);
};
export const listenForPrivateUserEvent = (userId, event, callback) => {
  return subscribeToPrivateUserChannel(userId)
    .listen(
      event,
      e => callback(e),
    );
};

export const listenForWebsiteEvent = (websiteId, event, callback) => {
  return subscribeToWebsiteChannel(websiteId)
    .listen(
      event,
      e => callback(e),
    );
};
